//@ts-nocheck
import { memo, useState } from "react";

import { BookingSchedule } from "components";

import _ from 'lodash'

import {
  quizListUrl,
  singleQuestUrl,
  questEventsListUrl,
  reviewsListUrl,
  statisticListUrl,
  questRaitingUrl,
} from "utils/api/requestUrls";

const QuestIframe = (props) => {
  const { responseBody, questFirstData, quizId } = props;

  const { name, address, questPrices } = questFirstData;

  const pageView = event => {
    window &&
      window.dataLayer &&
      window.dataLayer.push({
        event: event,
      });
  };

  const [isSuccessBooking, setIsSuccessBooking] = useState<boolean>(false);
  const [showBookingModal, setShowBookingModal] = useState<boolean>(false);


  const changeBookingState = (value: any) => {
    setIsSuccessBooking(value);
  };

  return (
    <div className={"flex items-center justify-center w-full"}>
      <BookingSchedule
        {...{
          schedule: responseBody,
          prices: questPrices,
          questName: name,
          questId: quizId,
          changeBookingState: changeBookingState,
          address,
          pageView: pageView,
          use: "quiz",
          questFirstData,
          isIframe: props.isIframe,
          showBookingModal: showBookingModal,
          setShowBookingModal: setShowBookingModal,
        }}
      />
    </div>
  );
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;
  let quizId: any;

  if (context.query.id == 1) {
    quizId = 6
  };

  if (context.query.id == 2) {
    quizId = 7
  };
  
  if (context.query.id == 3) {
    quizId = 14
  };

  if (context.query.id == 6) {
    quizId = 2
  };

  const questListResponse = await fetch(quizListUrl(null, null));
  const questListFirstData = await questListResponse.json();

  const questResponse = await fetch(singleQuestUrl(quizId));
  const questFirstData = await questResponse.json();

  const questEventsResponse = await fetch(questEventsListUrl(quizId));
  const questEventsFirstData = await questEventsResponse?.json();

  const reviewsResponse = await fetch(reviewsListUrl(quizId));
  const reviewsFirstData = await reviewsResponse?.json();

  const statisticResponse = await fetch(statisticListUrl(quizId));
  const statisticFirstData = await statisticResponse?.json();

  const raitingResponse = await fetch(questRaitingUrl(quizId));
  const raitingJSON = await raitingResponse?.json();

  const responseBody = Object.values(
    _.groupBy(questEventsFirstData.content, "startDate")
  );

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  }

  return {
    props: {
      quizId,
      questFirstData,
      responseBody,
      questListFirstData,
      statisticFirstData,
      overallRating: raitingJSON,
      questEventsFirstData: questEventsFirstData?.content,
      reviewsFirstData: reviewsFirstData?.content,
      isIframe: true,
    },
  };
};

export default memo(QuestIframe);
